import { render, staticRenderFns } from "./ConfirmaGNP.vue?vue&type=template&id=6e377a7a"
import script from "./ConfirmaGNP.vue?vue&type=script&lang=js"
export * from "./ConfirmaGNP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports